/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Name_FieldInputs */

const en_admin_roles_name_field = /** @type {(inputs: Admin_Roles_Name_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const zh_admin_roles_name_field = /** @type {(inputs: Admin_Roles_Name_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Admin_Roles_Name_FieldInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_name_field = /** @type {((inputs?: Admin_Roles_Name_FieldInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Name_FieldInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_name_field(inputs)
	return zh_admin_roles_name_field(inputs)
});
export { admin_roles_name_field as "admin.roles.name_field" }